import React, { useState, useEffect, useLayoutEffect  } from "react";
// import "../App.css";
import { Helmet } from "react-helmet-async";
import seoMeta from "./seoMeta";
import AnimatedCenterSection from "../components/AnimatedCenterSection";
import OurStory from "../components/OurStory";
import StoneSection from "../components/StoneSection";
import DivisionSection from "../components/DivisionSection";
import AboutBanner from "../components/About/AboutBanner";
import AboutVideoSection from "../components/About/AboutVideoSection";
import AboutContactCTA from "../components/About/AboutContactCTA";
import LookingForward from "../components/About/LookingForward";
import VCNRDifferentSection from "../components/About/VCNRDifferentSection";
import AboutFounderMessage from "../components/About/AboutFounderMessage";
import OurOriginStory from "../components/About/OurOriginStory";
import AboutValuesSection from "../components/About/AboutValuesSection";
import AboutCoreValues from "../components/About/AboutCorevalues";
import GroupStructureSection from "../components/About/GroupStructureSection";
import ParallaxSection from '../components/ParallaxSection'
import FAQ from "../components/FAQ";
import { useLocation } from 'react-router-dom';
import TimeFlow from "../components/About/TimeFlow";
import LogoLoader from "../components/LogoLoader";
import VCNRIntro from "../components/VCNRIntro";

const AboutVCNR = () => {
  const meta = seoMeta["/aboutVCNR"];
  const location = useLocation();
  useEffect(() => {
    const hash = location.hash?.replace('#', '');
    if (hash) {
      setTimeout(() => {
        const el = document.getElementById(hash);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  }, [location]);

const faqData = {
  "About VCNR Group": [
    { question: "What role does innovation play in VCNR’s journey?", answer: "We design smarter solutions, anticipate future needs, and push boundaries, always with the goal of making a real difference in people’s lives." },
    { question: "Where does VCNR Group make its mark?", answer: "From construction and technology to healthcare, agrotech, luxury retail, aerospace, and soon retail infrastructure with VCNR Mall, we build across industries with one goal: Lasting Impact." },
    { question: "Where is VCNR Group Located?", answer: "VCNR Group is Located in Bengaluru, Karnataka, with a presence across India and expanding global networks." },
  ],
  "For Investors": [
    { question: "Is VCNR Group open to external investment?", answer: "Yes, we welcome partial strategic investment partnerships that align with our values and long-term growth vision." },
    { question: "What makes VCNR an attractive investment opportunity?", answer: "Our ventures grow from solving real-world challenges, built with purpose, proven impact, and the agility to thrive in the future." },
    { question: "How can I express interest in investing with VCNR?", answer: "Please write to us at invest@vcnrgroup.com with your profile and area of interest. Our strategy team will connect with you." }
  ],
  "For Vendors & Partners": [
    { question: "I would like to work with VCNR as a vendor. How do I apply?", answer: "Simply email your credentials and offerings to vendors@vcnrgroup.com, we will be happy to explore how we can work together." },
    { question: "What does VCNR look for in vendor partnerships?", answer: "Integrity, quality, timely delivery, and a shared commitment to excellence are key parameters we value in vendor relationships." },
    { question: "Can start-ups collaborate with VCNR?", answer: "Absolutely. We actively collaborate with start-ups—especially in the tech, agri, and healthcare innovation space." }
  ],
  "Corporate Social Responsibility (CSR)": [
    { question: "Is VCNR involved in social impact or CSR initiatives?", answer: "Absolutely. Social impact is woven into who we are, from organising free medical camps and advancing rural tech education to creating women-led agri-innovation zones, our initiatives are designed to uplift communities and create lasting change." },
    { question: "Can NGOs or social enterprise partner with VCNR?", answer: "Yes. We welcome partnerships with mission-aligned NGOs and grassroots changemakers. Please reach out via csr@vcnrgroup.com." },
    { question: "What are the focus areas for VCNR’s CSR work?", answer: "Our focus areas include healthcare access, rural education, women's empowerment, sustainable agriculture, and inclusive technology." }
  ],
  "Careers at VCNR": [
    { question: "How do I apply for a job at VCNR Group?", answer: "Visit the Careers section on our website or email your resume and interest to careers@vcnrgroup.com." },
     { question: "Does VCNR offer internships?", answer: "Yes, we offer internships across functions, especially in Construction Tech, Healthcare innovation, and R&D." },
  ]
};

  return (
    <>

<Helmet>
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
        <meta name="keywords" content={meta.keywords} />
      </Helmet>

          {/* <div className="section-wrapper"><ParallaxSection><AboutBanner /></ParallaxSection></div> */}
 <div className="section-wrapper" id="AboutVideo"><AboutVideoSection /></div>
 {/* <div className="section-wrapper" id="OurOriginStory"><ParallaxSection id="OurStory"><OurStory /></ParallaxSection></div> */}
<div id="OurOriginStory"><TimeFlow /></div>
<div id="AboutValues"><AboutValuesSection /></div>
<div id="CoreValues"><ParallaxSection><AboutCoreValues /></ParallaxSection></div>
<div id="GroupStructure"><GroupStructureSection /></div>
<div id="FounderMessage"><AboutFounderMessage /></div>
<div className="section-wrapper" id="VCNRDifferent"><VCNRDifferentSection /></div>
<LookingForward />
<div id="ContactCTA"><ParallaxSection><AboutContactCTA /></ParallaxSection></div>
<div id="FAQ"><ParallaxSection><FAQ faqCategories={faqData} /></ParallaxSection></div>

          



    </>
  );
};

export default AboutVCNR;
